// import React from 'react';
import icon_doc_1 from '../images/icon_doc_1.png';
import docPodrazdelenii from './documents/documentsEducation/Polozhenie-o-strukturnom-podrazdelenii.doc';
import docPravila from './documents/documentsEducation/polozhenie-o-pravilah-priema-1.docx';
import docPoryadke from './documents/documentsEducation/Polozhenie-o-poryadke-oformleniya1.docx';
import docSoveteKursov from './documents/documentsEducation/Polozhenie-o-Sovete-kursov1.docx';
import docAttestaczii from './documents/documentsEducation/Polozhenie-ob-attestaczii-1.doc';
import docRezhime from './documents/documentsEducation/Polozhenie-o-rezhime-zanyatij-1.docx';
import docSoveteStudents from './documents/documentsEducation/Polozhenie-o-Sovete-obuchayushhihsya1.docx';
import docRasporyadka from './documents/documentsEducation/Pravila-vnutrennego-rasporyadka-dlya-slushatelej.docx';
import docKomissii from './documents/documentsEducation/polozhenie-o-Komissii-po-uregulirovaniyu-sporov-1.docx';
import docODistObuchenie from './documents/documentsEducation/polozhenie_o_distancionom_obuchenii.pdf';
import docFormObuchenie from './documents/documentsEducation/polozhenie_o_formah_na_kursach_GO.pdf';
// import doc from './documents/documentsEducation/test_pdf.pdf';
// import doc from './documents/documentsEducation/test_pdf.pdf';
// import doc from './documents/documentsEducation/test_pdf.pdf';
// import doc from './documents/documentsEducation/test_pdf.pdf';

// import pdfTest from './documentsMKU/test_pdf.pdf';

const documentsListEducation = [
  {
    titleDoc: 'Положение о структурном подразделении',
    typeDoc: icon_doc_1,
    path: docPodrazdelenii,
    docId: 1,
  },
  {
    titleDoc:
      'Положение о правилах приема и порядке перевода, отчисления и восстановления обучающихся (слушателей) Курсов гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docPravila,
    docId: 2,
  },
  {
    titleDoc:
      'Положение о порядке оформления возникновения, приостановления и прекращения отношений между образовательной организацией и обучающимися (слушателями) Курсов гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docPoryadke,
    docId: 3,
  },
  {
    titleDoc:
      'Положение о Совете курсов гражданской обороны муниципального казенного учреждения «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docSoveteKursov,
    docId: 4,
  },
  {
    titleDoc:
      'Положение о промежуточной и итоговой аттестации обучающихся (слушателей) Курсов гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docAttestaczii,
    docId: 5,
  },
  {
    titleDoc:
      'Положение о режиме занятий на Курсах гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docRezhime,
    docId: 6,
  },
  {
    titleDoc:
      'Положение о Совете обучающихся (слушателей) Курсов гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docSoveteStudents,
    docId: 7,
  },
  {
    titleDoc:
      'Правила внутреннего трудового распорядка для обучающихся (слушателей) Курсов гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docRasporyadka,
    docId: 8,
  },
  {
    titleDoc:
      'Положение о Комиссии по урегулированию споров между участниками образовательных отношений на Курсах гражданской обороны, защиты от чрезвычайных ситуаций и пожарной безопасности в муниципальном казенном учреждении «Аварийно-спасательная служба Северодвинска»',
    typeDoc: icon_doc_1,
    path: docKomissii,
    docId: 9,
  },
  {
    titleDoc: "Положение О применении электронного обучения и дистанционных образовательных технологий на Курсах ГО",
    typeDoc: icon_doc_1,
    path: docODistObuchenie,
    docId: 10,
  },
  {
    titleDoc: "Положение о формах обучения на Курсах ГО",
    typeDoc: icon_doc_1,
    path: docFormObuchenie,
    docId: 11,
  },
  // {
  //   titleDoc: "Название документа3",
  //   typeDoc: icon_doc_1,
  //   path: pdfTest,
  //   docId: 3,
  // },
  // {
  //   titleDoc: "Название документа3",
  //   typeDoc: icon_doc_1,
  //   path: pdfTest,
  //   docId: 3,
  // },
  // {
  //   titleDoc: "Название документа3",
  //   typeDoc: icon_doc_1,
  //   path: pdfTest,
  //   docId: 3,
  // },
  // {
  //   titleDoc: "Название документа3",
  //   typeDoc: icon_doc_1,
  //   path: pdfTest,
  //   docId: 3,
  // },
];

export default documentsListEducation;
